// extracted by mini-css-extract-plugin
export default {"modal":"IssueModal_modal__AhEAd","box":"IssueModal_box__PpBa7"};